const ProductionFlag = {
    BOTH_EU_PRODUCED_AND_IMPORTED: 'both',
    EU_IMPORTED: 'eu-imported',
    EU_PRODUCED: 'eu-produced',
    NO_DATA: 'no-data',

    toArray() {
        return [
            this.BOTH_EU_PRODUCED_AND_IMPORTED,
            this.EU_IMPORTED,
            this.EU_PRODUCED,
            this.NO_DATA
        ];
    }
};

export {
    ProductionFlag
};
